// src/components/LandingPage/data.ts
import svgPaths from "../../imports/svg-gs2djqzs4p";

// Images
export const imgImageAiPoweredCustomerExperiencePlatform =
  "https://placehold.co/600x320?text=AI+Platform";

export const imgInnovationJourney =
  "https://placehold.co/1280x720?text=Innovation+Journey";

// Quest Cards
export const questCards = [
  {
    title: "AI-powered Customer Experience Platform",
    team:
      "Cross-functional teams | AI Engineers, UX Designers, Data Scientists",
    timer: [
      { value: "03", label: "Days" },
      { value: "23", label: "Hrs" },
      { value: "48", label: "Mins" },
      { value: "26", label: "Secs" },
    ],
  },
  {
    title: "Blockchain for Supply Chain Transparency",
    team:
      "Blockchain Developers | Backend Engineers, Smart Contract Specialists",
    timer: [
      { value: "01", label: "Day" },
      { value: "02", label: "Hrs" },
      { value: "23", label: "Mins" },
      { value: "31", label: "Secs" },
    ],
  },
  {
    title: "Zero Trust Security for Cloud Native Applications",
    team:
      "Security Engineers | Cloud Architects, DevSecOps Specialists",
    timer: [
      { value: "01", label: "Day" },
      { value: "02", label: "Hrs" },
      { value: "23", label: "Mins" },
      { value: "31", label: "Secs" },
    ],
  },
];

// Steps
export const journeySteps = [
  "Select your quest",
  "Build your team",
  "Get mentorship",
  "Train and Learn",
  "Build and innovate",
  "Submit and present",
];

// Info cards
export const infoCards = [
  { label: "Learnathon", title: "Complete Training Modules" },
  { label: "Cloud Resources", title: "Access cloud credits & development tools" },
  { label: "Learn about Jury", title: "Understand the judging criteria" },
  { label: "Goal", title: "Build products from scratch" },
];

//Innovation Cards
export const dnaCards = [
  {
    iconPath: svgPaths.p1af45800,
    viewBox: "0 0 45 45",
    title: "Ideathon",
    desc: "Got a spark of genius? Drop your idea—let's turn it into the next big challenge!",
    cta: "Post/View real world problems",
    arrowPath: svgPaths.p2d3e6e00,
    arrowViewBox: "0 0 20.36 20.88",
    // icon styling
    stroke: "#171A22",
    strokeWidth: 2.8,
    linecap: "round" as const,
    linejoin: "round" as const,
  },
  {
    iconPath: svgPaths.pda1800,
    viewBox: "0 0 42.45 49.45",
    title: "Learnathon",
    desc: "Dive into the resource vault and start grinding your way to mastery.",
    cta: "Knowledge treasure chest",
    arrowPath: svgPaths.p4a1d79c,
    arrowViewBox: "0 0 24 24",
    // filled icon
    fill: "#171A22",
  },
  {
    iconPath: svgPaths.p1b223e80,
    viewBox: "0 0 49.45 49.45",
    title: "Hackathon",
    desc: "Assemble your squad, dive into the challenge, and build solutions that level up the future.",
    cta: "Build disruptive solutions",
    arrowPath: svgPaths.pb508a00,
    arrowViewBox: "0 0 24 20.88",
    stroke: "#171A22",
    strokeWidth: 2.8,
    linecap: "round" as const,
    linejoin: "round" as const,
  },
];

export { svgPaths };